<template>
  <div class="turnlog-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  placeholder="选择状态">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
  </div>
</template>
  
  <script>

export default {
  name: 'turnlog-list',
  data () {
    return {
      statusList: [
        { id: 1, name: "未接收" },
        { id: 2, name: "已接收" },
        { id: -1, name: "拒绝接收" }
      ],
      goods: {
      },
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'status': ""
      },
      list: [
        {
          title: 'Id',
          key: 'turn_id',
          fixed: 'left',
          width: 90
        },
        {
          title: '轮转哈希值',
          key: 'turn_blockchain_id',
          minWidth: 200
        },
        {
          title: '藏品',
          key: 'product_name',
          minWidth: 250,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "名称：" + params.row.product_name
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "哈希值：" + params.row.product_blockchain_id
              ),
            ]);
          }
        },
        {
          title: '转赠状态',
          key: 'receive_status',
          minWidth: 150,
        },
        {
          title: '接收时间',
          key: 'receive_at',
          minWidth: 150,
        },
        {
          title: '藏家',
          key: 'collector_name',
          minWidth: 80,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "名称：" + params.row.collector_name
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "手机号：" + params.row.collector_phone
              ),
            ]);
          }
        },
        {
          title: '接收藏家',
          key: 'receiver_name',
          minWidth: 80,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "名称：" + params.row.receiver_name
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "手机号：" + params.row.receiver_phone
              ),
            ]);
          }
        },
        {
          title: '转赠时间',
          key: 'created_at',
          minWidth: 100,
        },
      ],
      tablelist: [],
      showModalStatus: false,
      id: 0,

    }
  },
  created: function () {
    this.getTableList();
  },
  components: {
  },

  methods: {
    getTableList: function () {
      this.$api.turnlog.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 详情
    detail (id) {
      this.title = "详情";
      this.showModalStatus = !this.showModalStatus;
      this.$api.product.detail({ id: id }).then(res => {
        this.goods = res.result;
        this.$refs['editContent'].message = res.result.content;

      });
    },

    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        status: this.formItem.status,
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.turnlog.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  },
}
  </script>

  